export import React = require('react');
export import models = require("app/models/requireme");
import * as rx from "rxjs";
import { observeResource } from "kea-resource";

import * as resources from "app/resources/index";
import { SelectorSimpleFactory, SelectorFiltradoFactory, SelectorEnumFactory } from "../logic";
import * as kea from "kea-react";


export interface FiltroCajas {
    idSucursal?: number;
}
function filtrarItem(caja: models.CajaDTO, filtro: FiltroCajas | undefined) {
    return !filtro || !filtro.idSucursal || caja.IdSucursal == filtro.idSucursal;
}
/**Selector de una caja, por default estan filtradas las cajas de la sucursal del usuario actual. El filtro se puede sobreescribir   */
export const Caja = SelectorFiltradoFactory<models.CajaDTO, FiltroCajas>((filtro) => observeResource(resources.Caja.query).map(cajas => cajas.filter(x => filtrarItem(x, filtro))), x => x.IdRegistro, x => x.NombreSucursal + " - " + x.Nombre)


// WEBPACK FOOTER //
// ./app/features/selectores/items/cajas.tsx